module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-file-274f6af749d7558bafc973785a735dda.png";